<ng-container>
  <div
    [ngClass]="{ 'd-flex justify-content-start': decorate }"
    [ngStyle]="{ 'flex-wrap': wrapContent ? 'wrap' : '' }"
  >
    <ng-container *ngIf="!rowData?.length">
      <div [ngClass]="{ emptyRow: decorate }">
        <span>
          {{ noDataMessage }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngFor="let row of rowValue.display; let i = index">
      <!-- nebular tags can be used here in future [not present in the current version] -->
      <label
        [ngClass]="{
          'custom-badge badge badge-pill p-2 mx-1': decorate,
          'mt-2': !removeTagTopSpacing,
          'p-1': !decorate && i !== 0,
          'd-none': (dataObject && !row?.name) || (!dataObject && !row),
          primaryBG: decorate && status === 'primary',
          successBG: decorate && status === 'success',
          dangerBG: decorate && status === 'danger'
        }"
        (click)="navigateEvent(row)"
      >
        <span [class]="nonLinkClass" *ngIf="!showAsLink">{{
          dataObject ? row?.name : row
        }}</span>
        <app-smart-table-routerlink
          *ngIf="showAsLink"
          [renderValue]="{
            display: dataObject ? row?.name : row,
            url: row?.url?.length ? row.url : allURLs?.length ? allURLs[i] : '',
            class: linkClass,
            disableLink: row?.disableLink || false,
            linkTooltip: row?.linkTooltip || '',
            extraParams: row?.extraParams || null
          }"
        ></app-smart-table-routerlink>
      </label>
    </ng-container>
    <button
      nbButton
      size="small"
      *ngIf="
        (isRowList && rowValue?.hide?.length) ||
        (!isRowList && rowValue?.hide[0]?.length)
      "
      nbPopoverClass="hiddenDataPopover"
      [nbPopover]="hiddenData"
      nbPopoverPlacement="bottom"
      nbPopoverAdjustment="vertical"
      nbPopoverTrigger="click"
      id="ellipsisIcon"
    >
      <label
        class="ml-1 cursor-pointer"
        [ngClass]="{
          'mt-2': !removeTagTopSpacing
        }"
        *ngIf="isRowList && rowValue?.hide?.length"
        style="text-transform: lowercase"
        (click)="onMoreClick($event)"
      >
        & {{ rowValue?.hide?.length }} more</label
      >

      <i
        class="eva-more-horizontal-outline eva"
        *ngIf="!isRowList && rowValue?.hide[0]?.length"
      ></i>
    </button>
  </div>
</ng-container>

<ng-template #hiddenData let-data>
  <nb-card
    style="
      background-color: var(--card-dark-background-color);
      margin: 0;
      max-width: 30rem;
      max-height: 25rem;
      overflow-y: scroll;
    "
  >
    <div class="d-flex justify-content-start p-1 flex-wrap">
      <ng-container *ngFor="let row of rowValue?.hide; let i = index">
        <label
          [ngClass]="{
            'custom-badge badge badge-pill p-2 mt-2 mx-1 lightBG': decorate,
            'p-1 mt-1 whiteColorBase': !decorate,
            'd-none': (dataObject && !row?.name) || (!dataObject && !row)
          }"
          (click)="navigateEvent(row)"
        >
          <span [class]="nonLinkClass" *ngIf="!showAsLink">{{
            dataObject ? row?.name : row
          }}</span>
          <app-smart-table-routerlink
            *ngIf="showAsLink"
            [renderValue]="{
              display: dataObject ? row?.name : row,
              url: row?.url?.length
                ? row.url
                : allURLs?.length
                ? allURLs[defaultDisplay + i]
                : '',
              class: !decorate ? 'whiteColorBase' : '',
              linkUnderline: linkUnderline,
              disableLink: row?.disableLink || false,
              linkTooltip: row?.linkTooltip || '',
              extraParams: row?.extraParams || null
            }"
          ></app-smart-table-routerlink>
        </label>
      </ng-container>
    </div>
  </nb-card>
</ng-template>
